<template>
  <div class="py-5 bg-white">
    <div class="container">
      <Dates :types="types" :theme-color="surrounding.style"/>
    </div>
  </div>
</template>

<script>
import Dates from '@enjoj/dates'
import '@enjoj/dates/package/dist/dates.css'

export default {
  name: 'ec-business-dates',
  components: {
    Dates
  },
  props: {
    item: {
      type: Object,
      default () {
        return {}
      }
    },
    surrounding: {
      type: Object,
      default () {
        return {}
      }
    }
  },
  computed: {
    types () { return this.item.itemable.date_types }
  }
}
</script>
